import { render, staticRenderFns } from "./CreateAdministratorModal.vue?vue&type=template&id=51262334&scoped=true&"
import script from "./CreateAdministratorModal.vue?vue&type=script&lang=js&"
export * from "./CreateAdministratorModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateAdministratorModal.vue?vue&type=style&index=0&id=51262334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51262334",
  null
  
)

export default component.exports